"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    jiaHeavenly: 'Giáp',
    yiHeavenly: 'Ất',
    bingHeavenly: 'Bính',
    dingHeavenly: 'Đinh',
    wuHeavenly: 'Mậu',
    jiHeavenly: 'Kỷ',
    gengHeavenly: 'Canh',
    xinHeavenly: 'Tân',
    renHeavenly: 'Nhâm',
    guiHeavenly: 'Quý',
};
